import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Tag } from '@apps/cmdb/models';

@Component({
    selector: 'aa-chips-tags-container',
    templateUrl: './chips-tags-container.component.html',
    styleUrls: [
        './chips-tags-container.component.scss'
    ],
    standalone: false
})
export class ChipsTagsContainerComponent
{
    @Input() tags: Tag[];
    @Input() isFiltrable: boolean;
    @Output() public attachTagEvent: EventEmitter<string> = new EventEmitter();
    @Output() public detachTagEvent: EventEmitter<string> = new EventEmitter();
    @Output() public tagClickEvent: EventEmitter<Tag> = new EventEmitter();

    public onAttachTagEvent (tagId: string): void
    {
        this.attachTagEvent.emit(tagId);
    }

    public onDetachTagEvent (tagId: string): void
    {
        this.detachTagEvent.emit(tagId);
    }

    public onTagClickEvent (tag: Tag): void
    {
        this.tagClickEvent.emit(tag);
    }
}
